import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { faCheck, faTimes, faBell, faPlus, faLightbulb, faComments, faMinus, faEdit } from '@fortawesome/free-solid-svg-icons'
import { AngelService } from '../services/angel.service';

import { eAlert, eFAQ } from '../services/entities'
import { GsapService } from '../services/gsap.service'
import { HaylieService } from '../services/haylie.service'
import { MorganaService } from '../services/morgana.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-page-faqs',
  templateUrl: './page-faqs.component.html',
  styleUrls: ['./page-faqs.component.css']
})
export class PageFaqsComponent implements OnInit {
  player_live = false;
  player_permission = 0 ;
  model_title: string = 'FAQs';
  model_faqs: eFAQ[] = [];
  model_type : string = 'faqs'
  page_frm: boolean = false;
  lhaylie: any;
  lmorgana: any;

  model_frm_id = 0;
  model_frm_question = '';
  model_frm_answer = '';

  FAIcon = faComments;
  FAIconDelete = faTimes;
  FAIconNew = faPlus;
  FAIconPlus = faPlus;
  FAIconMinus = faMinus;
  frmFAIcon = faEdit;

  @Input() activated: boolean = false;  

  @ViewChild('faq_question') frmquestion:any;
  @ViewChild('faq_answer') frmanswer:any;
    

  subs = new Subscription;

  constructor(private gsap: GsapService, 
      private haylie: HaylieService,
      private morgana: MorganaService,
      public angel: AngelService,  
      private cdr: ChangeDetectorRef,
      private router: Router) 
    { 
      this.lhaylie = this.haylie;
      this.lmorgana = this.morgana;
    }

  ngOnInit(): void {
    
  }

  ngOnChanges() { 
    if (this.activated) this.content_refresh();
  }

  switchFrm(p_action:string):void {
    
    if (p_action == 'on') {
      this.model_frm_id = 0; 
      this.model_frm_question = ''; 
      this.model_frm_answer = '';
    
      this.page_frm = true;
      this.gsap.magic_trg('#frmfaq', 'easybuild');
      this.gsap.magic_trg('#page_plans .fixed_action', 'vanish');
    }
    else { 
      this.gsap.magic_trg('#frmplan', 'easyvanish');
      this.gsap.magic_trg('#page_plans .fixed_action', 'easybuild');
      this.page_frm = false;
    }

  }
  content_refresh() {
    this.gsap.anima_trg('cronos', 'showup');
    
    this.model_type = this.angel.player_compass(true, '');
    this.model_title = "FAQs";
    
    if (this.haylie.player_token(true, '').length > 0) {
      console.log('getfaqs> ' + this.haylie.player_token(true, ''));
      this.get_faqs();
      
      this.player_live = this.haylie.player_token(true, '').length > 0;
    }
    else {
      this.player_live = false; 

      this.gsap.magic_trg("#outsider_wrapper", "build");
      this.router.navigateByUrl('octalogin');
    }
  }
  get_faqs(): void {
    this.model_faqs = [];

    this.subs.add(this.haylie.get_faqs().subscribe({
      next: (faqs) => {
        this.model_faqs = faqs.map(faq => ({
          ...faq,
          open: false 
        }));

      //this.page_loading = true;
      this.gsap.anima_trg('cronos', '');

        this.cdr.detectChanges();
      },
      error: console.error
    }));

  }
  catch_faqs = (p_response: any) =>  {
    var l_response = JSON.parse(p_response);
    this.model_faqs = l_response.faqs;

    this.gsap.anima_trg('cronos', '');
    return this.model_faqs;
  }

  
  goHaylie(p_action: string, p_target: string): void{
      console.log(p_action + ">" + p_target);
    
      switch(p_action) {
        case "frm":
          this.gsap.anima_trg('cronos', 'showup');
          var frmcheck = true;
          var obj = new eFAQ();
  
          if (this.frmanswer.nativeElement.value.length <= 0)
          { frmcheck = false; console.log('frmerror> missing frmanswer'); }
          else  
            obj.answer = this.frmanswer.nativeElement.value;
  
          if (this.frmquestion.nativeElement.value.length <= 0)
          { frmcheck = false; console.log('frmerror> missing frmquestion'); }
          else  
            obj.question = this.frmquestion.nativeElement.value;
          
          
          if (frmcheck) {
            obj.id = this.model_frm_id;
  
            this.switchFrm("off");
            
            this.haylie.send_faq(obj).then(this.catch_frm);
            console.log('done.');
          }
          else {
            this.gsap.magic_trg("#frmfaq", "blink");
            this.gsap.anima_trg('cronos', '');
          }
        break;
  
        case "delete": 
          console.log('haylie.kill-faq>' + this.model_frm_id);
  
          this.haylie.kill_content("faq", this.model_frm_id.toString()).subscribe(
            (res) => { 
              this.content_refresh();
          
            }); 
          break;
  
        case "edit": 
          console.log('haylie.edit-faq>' + p_target);
          this.model_frm_id = parseInt(p_target); 
          var register = this.model_faqs.filter((x) => x.id.toString() == p_target); 
          this.switchFrm("on");
  
          this.model_frm_id = parseInt(p_target); 
          this.model_frm_question = register[0].question; 
          this.model_frm_answer = register[0].answer;
          
          break;
      }
    }
  catch_frm = (p_response:any) => {
    this.content_refresh();
  }

}
